exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add_user_form .form_input_field.radio {\n  display: block;\n}\n.add_user_form .form_input_field.radio {\n  display: block;\n}\n.add_user_form .form_input_field.radio p {\n  margin: 0 0 15px;\n}\n.add_user_form .form_input_field.radio .first_child {\n  margin-left: 0;\n}\n.add_user_form mat-card {\n  margin: 0 0 30px;\n  background: #f7fbfe;\n}\n.add_user_form mat-card h3 {\n  font-size: 0.9em;\n  color: #838d8e;\n}\n.add_user_form mat-card p {\n  font-size: 1.3em;\n  font-family: 'robotomedium';\n  text-transform: uppercase;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/admin/adduser/adduser.component.css
// module id = ../../../../../src/app/components/pages/users/admin/adduser/adduser.component.css
// module chunks = main